import { render, staticRenderFns } from "./dashboard-module-shared-widgets-new-case-widget.vue?vue&type=template&id=23f166b9&scoped=true&"
import script from "./dashboard-module-shared-widgets-new-case-widget.ts?vue&type=script&lang=ts&"
export * from "./dashboard-module-shared-widgets-new-case-widget.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-module-shared-widgets-new-case-widget.scss?vue&type=style&index=0&id=23f166b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f166b9",
  null
  
)

export default component.exports